import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import FormLabel from '@material-ui/core/FormLabel';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { blackColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  labelHorizontal: extendedFormsStyle.labelHorizontal,
  caloriesLabel: {
    marginLeft: '180px',
    color: blackColor,
  },
  calorificSizeWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  checkboxWrapper: {
    minWidth: '180px',
  },
});

const CheckSizes = ({ sizes, handleToggle, handleCalories }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (!sizes) {
    return null;
  }
  return (
    <GridContainer>
      <GridItem xs={12} sm={12}>
        <FormLabel className={classes.labelHorizontal}>
          {t('form.sizesAndCalories')}
        </FormLabel>
      </GridItem>
      <GridItem xs={12} sm={12}>
        <div className={classes.caloriesLabel}>{t('form.caloriesValue')}</div>

        {sizes.map((size, index) => (
          <div key={size.id} className={classes.calorificSizeWrapper}>
            <div className={classes.checkboxWrapper}>
              <LabeledCheckbox
                onClick={() => handleToggle(index, size.disabled)}
                checked={!!size.checked}
                label={`${t('form.size')} ${size.name}`}
              />
            </div>
            <CustomInput
              formControlProps={{
                id: size.id,
              }}
              inputProps={{
                type: 'number',
                onChange: event => handleCalories(index, event),
                disabled: size.checked !== true,
                value: size.checked ? size.calories : '',
              }}
            />
          </div>
        ))}
      </GridItem>
    </GridContainer>
  );
};

export default CheckSizes;
